// src/pages/CampaignFlow/phases/Phase1Profile.jsx
import React, { useState } from 'react';
import { CpuChipIcon } from '@heroicons/react/24/outline';
import apiClient from '../../../lib/apiClient';

const isValidUrl = (val) => {
  try { new URL(val); return true; } catch { return false; }
};

export default function Phase1Profile({ onNext }) {
  const [campaignName, setCampaignName] = useState('');
  const [objective, setObjective]       = useState('');
  const [isLink, setIsLink]             = useState(false);
  const [loading, setLoading]           = useState(false);
  const [errors, setErrors]             = useState({});

  const validate = () => {
    const e = {};
    if (campaignName.trim().length < 3)  e.campaignName = 'Mínimo 3 caracteres';
    if (objective.trim().length < 3)     e.objective    = 'Mínimo 3 caracteres';
    if (isLink && !isValidUrl(objective)) e.objective   = 'URL inválida (ex: https://meusite.com)';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleNext = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const r = await apiClient.request('/campaign', {
        method: 'POST',
        body: JSON.stringify({
          business_name: campaignName.trim(),
          product_name:  objective.trim(),
          niche:         isLink ? 'link' : 'objetivo',
        }),
      });
      const d = await r.json();
      if (d.success) {
        // Persiste ID no localStorage para o painel /mp/dashboard
        const stored = JSON.parse(localStorage.getItem('mp_campaign_ids') || '[]');
        if (!stored.includes(d.campaign_id)) {
          stored.push(d.campaign_id);
          localStorage.setItem('mp_campaign_ids', JSON.stringify(stored));
        }
        onNext({ campaignId: d.campaign_id, campaignName, objective, isLink });
      } else {
        setErrors({ general: d.message || 'Erro ao criar campanha' });
      }
    } catch {
      setErrors({ general: 'Erro de conexão. Tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = campaignName.trim().length >= 3 && objective.trim().length >= 3;

  return (
    <div className="cf-phase cf-phase--profile">
      <div className="cf-mascot-row">
        <CpuChipIcon className="cf-mascot" style={{ width: 32, height: 32 }} />
        <div className="cf-mascot-speech">
          Vamos criar sua campanha! Primeiro me conta sobre o seu negócio.
        </div>
      </div>

      <div className="cf-glass-card">
        <h2 className="cf-phase__title">Nome da Campanha</h2>
        <p className="cf-phase__sub">Como você quer chamar essa campanha?</p>

        <div className="cf-field">
          <input
            className={`cf-input ${errors.campaignName ? 'cf-input--error' : ''}`}
            placeholder="Ex: Promoção de Verão 2026"
            value={campaignName}
            maxLength={80}
            onChange={e => { setCampaignName(e.target.value); setErrors(p => ({ ...p, campaignName: '' })); }}
          />
          {errors.campaignName && <span className="cf-field-error">{errors.campaignName}</span>}
        </div>

        <div className="cf-toggle-row">
          <span className="cf-toggle-label">Link externo?</span>
          <button
            className={`cf-toggle-btn ${isLink ? 'cf-toggle-btn--on' : ''}`}
            onClick={() => setIsLink(v => !v)}
          >
            {isLink ? 'Sim' : 'Não'}
          </button>
        </div>

        <div className="cf-field">
          <input
            className={`cf-input ${errors.objective ? 'cf-input--error' : ''}`}
            placeholder={isLink ? 'https://meusite.com.br' : 'Ex: Vender curso de culinária online'}
            value={objective}
            onChange={e => { setObjective(e.target.value); setErrors(p => ({ ...p, objective: '' })); }}
          />
          {errors.objective && <span className="cf-field-error">{errors.objective}</span>}
        </div>

        {errors.general && <div className="cf-alert cf-alert--error">{errors.general}</div>}

        <button
          className="cf-btn cf-btn--primary cf-btn--full"
          onClick={handleNext}
          disabled={!canSubmit || loading}
        >
          {loading ? 'Salvando...' : 'Próximo: Criação →'}
        </button>
      </div>
    </div>
  );
}
